module.exports = __webpack_public_path__ + "img/casa-mae-da-rota-de-vinhos.12ee201e.jpg";